/** @fileoverview Reads a hosted app address label into its slug and whether it is a preview. */

const SLUG_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
const PREVIEW_SUFFIX = '--preview';
const MAX_ADDRESS_LENGTH = 63;

export type AppAddress = {
  slug: string;
  isPreview: boolean;
};

/** Returns the slug and preview flag for `<slug>` or `<slug>--preview` (whole label fits one DNS label), else null. */
export const parseAppAddress = (label: string): AppAddress | null => {
  if (label.length > MAX_ADDRESS_LENGTH) {
    return null;
  }
  const isPreview = label.endsWith(PREVIEW_SUFFIX);
  const slug = isPreview ? label.slice(0, -PREVIEW_SUFFIX.length) : label;
  return SLUG_PATTERN.test(slug) ? { slug, isPreview } : null;
};

/** Returns true when the label is a live or preview app address. */
export const isValidAppAddress = (label: string) => parseAppAddress(label) !== null;
